import { useTheme } from '@wemogy/reactbase';
var useAuthorizationTheme = function () { return useTheme().pluginThemes.authorization; };
export default useAuthorizationTheme;
//# sourceMappingURL=UseAuthorizationTheme.js.map